import { Component } from '@angular/core';
import { LocalizationFieldBase } from '../localization-field.base';

@Component({
  selector: 'app-localization-text-form-field',
  templateUrl: '../localization-field.component.html',
  styleUrls: ['../localization-field.component.scss']
})
export class LocalizationTextFormFieldComponent extends LocalizationFieldBase { }
